export default __webpack_public_path__ + "static/media/pfpb.75e01fcb.jpg";